import React from 'react'
import { Tooltip, TooltipId } from '@mobi/component-library/Overlays/Tooltip'
import { Placement } from '@floating-ui/react-dom'

export const BetLoopSportTooltip: React.FC<{
  triggerElRef: React.RefObject<HTMLElement>
  onDismissed(): void
  tooltipId: TooltipId
  yPos?: number
  xPos?: number
  placement?: Placement
}> = ({ triggerElRef, onDismissed, tooltipId, yPos, xPos, placement }) => {
  return (
    <Tooltip
      color='blue'
      triggerElRef={triggerElRef}
      tooltipId={tooltipId}
      hasTooltipBeenSeen={() => false}
      shouldHideCrossIcon
      shouldOnlyRenderSingleInstance={true}
      offsetYPx={yPos}
      offsetXPx={xPos}
      onDismissed={onDismissed}
      strategyPosition='fixed'
      preferredPlacement={placement ?? 'top-end'}
    >
      <center>
        Now share your Sport
        <br />
        bets to Bet Loop
      </center>
    </Tooltip>
  )
}
